import { BrowserRouter } from "react-router-dom";
import AllRoutes from "routes/Routes";
import { ScrollToTop } from "react-router-scroll-to-top";
import { Toaster } from "react-hot-toast";
import Footer from "components/Home/Footer/Footer";
import Header from "components/Home/Header/Header";
import ReactTooltip from "react-tooltip";
import WithAuthenticationContext from "Authentication/AuthenticationContext.ts";
import { useContext, useEffect } from "react";
import CartModal from "common/order/CartModal";

import WithAuthentication from "Authentication/WithAuthentication.tsx";
import { CartItemsProvider } from "context/CardItems";
import { useState } from "react";
import { Helmet } from "react-helmet";
import GMlogo from "./assets/images/sitelogo.svg";

function App() {
  const auth = useContext(WithAuthenticationContext);
  const [backButtonPressed, setBackButtonPressed] = useState(false);
  useEffect(() => {
    window.onpopstate = () => {
      setBackButtonPressed(prev => !prev);
    };
  }, []);
  return (
    <>
      <Helmet>
        <link rel="shortcut icon" href={`${GMlogo}`} />
      </Helmet>
      <div className="App">
        <CartItemsProvider>
          <div>
            <Toaster />
          </div>
          <WithAuthentication>
            <BrowserRouter>
              <ScrollToTop />
              {/* layouts */}
              <Header backButtonPressed={backButtonPressed} />
              {auth.userInfo.userType == 1 && <CartModal></CartModal>}

              <AllRoutes></AllRoutes>
              <Footer />
            </BrowserRouter>
          </WithAuthentication>
        </CartItemsProvider>
      </div>
      <ReactTooltip id="gm-tooltip" className="tooltip-style" />
    </>
  );
}

export default App;
